"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var SearchResultItemDesktop_v2_1 = __importDefault(require("./SearchResultItemDesktop_v2"));

var frontend_common_1 = require("@ryerson/frontend.common");

var SearchResultItemMobile_v2_1 = __importDefault(require("./SearchResultItemMobile_v2"));

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var SearchResultsContext_v2_1 = require("./SearchResultsContext_v2");

var common_permissions_1 = require("@ryerson/common.permissions");

var DeliveryTimesRequestMapper_1 = require("../Header/Helpers/DeliveryTimesRequestMapper");

var axios_1 = __importDefault(require("axios"));

var SearchResultItem_v2 = function SearchResultItem_v2(_ref) {
  var isMobile = _ref.isMobile,
      item = _ref.item,
      index = _ref.index;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      hasPermission = _ref2.hasPermission,
      language = _ref2.localization.language,
      profile = _ref2.profile,
      axiosInstance = _ref2.axiosInstance,
      isLoggedIn = _ref2.user.isLoggedIn,
      zipCode = _ref2.zipCode;

  var _ref3 = (0, frontend_e_commerce_1.useEcommerce)(),
      addToCart = _ref3.addToCart,
      customerPickup = _ref3.customerPickup,
      defaultShipToAddress = _ref3.defaultShipToAddress,
      selectedShipToAddress = _ref3.selectedShipToAddress,
      salesPlant = _ref3.salesPlant,
      setSearchAddedToCart = _ref3.setSearchAddedToCart;

  var _ref4 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      deliveryTimes = _ref4.deliveryTimes,
      setDeliveryTimes = _ref4.setDeliveryTimes,
      setTriggerDeliveryTimes = _ref4.setTriggerDeliveryTimes,
      stateMessenger = _ref4.stateMessenger,
      storeDirectory = _ref4.storeDirectory;

  var _ref5 = (0, frontend_application_1.useNotifications)(),
      addNotification = _ref5.addNotification;

  var _ref6 = (0, frontend_common_1.getUsersDefaultUomValue)(item, profile),
      defaultQtyUom = _ref6.defaultQtyUom,
      defaultPricingUom = _ref6.defaultPricingUom,
      qtyUomOption = _ref6.qtyUomOption,
      pricingUomOption = _ref6.pricingUomOption;

  var _ref7 = (0, react_1.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      hasMounted = _ref8[0],
      setHasMounted = _ref8[1];

  var _ref9 = (0, react_1.useState)([]),
      _ref10 = _slicedToArray(_ref9, 2),
      message = _ref10[0],
      setMessage = _ref10[1];

  var _ref11 = (0, react_1.useState)(0),
      _ref12 = _slicedToArray(_ref11, 2),
      quantity = _ref12[0],
      setQuantity = _ref12[1];

  var _ref13 = (0, react_1.useState)(defaultQtyUom),
      _ref14 = _slicedToArray(_ref13, 2),
      quantityMeasure = _ref14[0],
      setQuantityMeasure = _ref14[1];

  var _ref15 = (0, react_1.useState)(defaultPricingUom),
      _ref16 = _slicedToArray(_ref15, 2),
      pricingMeasure = _ref16[0],
      setPricingMeasure = _ref16[1];

  var _ref17 = (0, react_1.useState)({}),
      _ref18 = _slicedToArray(_ref17, 2),
      queryParams = _ref18[0],
      setQueryParams = _ref18[1];

  var _ref19 = (0, react_1.useState)(""),
      _ref20 = _slicedToArray(_ref19, 2),
      queryString = _ref20[0],
      setQueryString = _ref20[1];

  var _ref21 = (0, react_1.useState)(false),
      _ref22 = _slicedToArray(_ref21, 2),
      isDebouncing = _ref22[0],
      setIsDebouncing = _ref22[1];

  var _ref23 = (0, react_1.useState)(false),
      _ref24 = _slicedToArray(_ref23, 2),
      hasError = _ref24[0],
      setHasError = _ref24[1];

  var _ref25 = (0, react_1.useState)([]),
      _ref26 = _slicedToArray(_ref25, 2),
      deliveryTimesForSingleItem = _ref26[0],
      setDeliveryTimesForSingleItem = _ref26[1];

  var _ref27 = (0, react_1.useState)(undefined),
      _ref28 = _slicedToArray(_ref27, 2),
      leadTimeDays = _ref28[0],
      setLeadTimeDays = _ref28[1];

  var addDefaultSrc = function addDefaultSrc(event) {
    if (!event.target.src.includes("/NoImageImage.svg")) {
      event.target.src = "/NoImageImage.svg";
    }
  };

  var getCorrectCase = function getCorrectCase(word) {
    return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : "";
  };

  var canCartViewEdit = function canCartViewEdit() {
    return hasPermission(common_permissions_1.Permission.Cart_View_Edit);
  };

  var findProductLeadTime = function findProductLeadTime(deliveryTimes) {
    return deliveryTimes.find(function (times) {
      return times.materialSku === item.materialMaster;
    });
  };
  /** @desc -Listener for Pub Sub Messages from other components 	*/

  /* Note: the use of publishing messages (pubsub) to receive messages from quantityUOm Component
          if value is true  of "is-debouncing" then we are currently debouncing
  */


  (0, react_1.useEffect)(function () {
    var _message = _slicedToArray(message, 2),
        messageString = _message[0],
        value = _message[1];

    if (messageString === "is-debouncing") {
      setIsDebouncing(value);
    }
  }, [message]);
  (0, react_1.useEffect)(function () {
    if (hasMounted) {
      // Subscribe to pub-sub  stateMessenger
      stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function (msg, value, topic) {
        return setMessage([msg, value, topic]);
      });
    }
  }, [hasMounted]);
  (0, react_1.useEffect)(function () {
    setHasMounted(true);
    return function () {
      setMessage([]);
      stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function () {
        return undefined;
      })();
    };
  }, []);
  (0, react_1.useEffect)(function () {
    var _a;

    if (deliveryTimes.length) {
      setLeadTimeDays((_a = findProductLeadTime(deliveryTimes)) === null || _a === void 0 ? void 0 : _a.leadTimeDays);
    }
  }, [deliveryTimes]);
  (0, react_1.useEffect)(function () {
    var _a;

    if (deliveryTimesForSingleItem.length) {
      setLeadTimeDays((_a = findProductLeadTime(deliveryTimesForSingleItem)) === null || _a === void 0 ? void 0 : _a.leadTimeDays);
    }
  }, [deliveryTimesForSingleItem]);
  var generateProductUrl = (0, react_1.useMemo)(function () {
    var formattedQueryString = queryString ? "?".concat(queryString) : "";
    return "".concat(item === null || item === void 0 ? void 0 : item.id).concat(formattedQueryString);
  }, [queryString]);
  (0, react_1.useEffect)(function () {
    setQueryString(Object.keys(queryParams).map(function (key) {
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(queryParams[key]));
    }).join("&"));
  }, [JSON.stringify(queryParams)]); //Use Typed a value to debounce

  (0, react_1.useEffect)(function () {
    var unmounted = false;
    var cTokenSource = axios_1.default.CancelToken.source();
    var cTokenObject = {
      cancelToken: cTokenSource.token
    };

    if (quantity) {
      setLeadTimeDays(undefined);
      setTriggerDeliveryTimes(false);
      var itemsAvailabilityRequest = (0, DeliveryTimesRequestMapper_1.createItemsAvailabilityRequest)([item], isLoggedIn, selectedShipToAddress ? selectedShipToAddress : defaultShipToAddress, defaultShipToAddress, customerPickup, salesPlant, zipCode, {
        materialSku: item.materialMaster,
        quantity: Number(quantity),
        quantityUom: quantityMeasure,
        pricingUom: pricingMeasure,
        itemNumber: 1
      }, profile); //Success Callback

      var handleDeliveryTimesSuccess = function handleDeliveryTimesSuccess(response) {
        var responseData = response === null || response === void 0 ? void 0 : response.data;

        if (responseData) {
          !unmounted && setDeliveryTimesForSingleItem(responseData);
        } else {
          !unmounted && setDeliveryTimesForSingleItem([]);
        }
      }; //Error Callback


      var handleError = function handleError() {};

      (0, frontend_common_1.getDeliveryTimes)(itemsAvailabilityRequest, axiosInstance, handleDeliveryTimesSuccess, handleError, cTokenObject);
    }

    return function () {
      //cleanup
      unmounted = true;
      cTokenSource.cancel("Cancelling in cleanup");
    };
  }, [quantity, quantityMeasure, pricingMeasure]);

  var onPricingMeasureChange = function onPricingMeasureChange(value) {
    setPricingMeasure(value);
    setQueryParams(Object.assign(Object.assign({}, queryParams), {
      priceUom: value
    }));
  };

  var onQuantityUpdate = function onQuantityUpdate(quantity, uom) {
    if (quantity) {
      setQuantity(quantity);
      setQuantityMeasure(uom);
      setQueryParams(Object.assign(Object.assign({}, queryParams), {
        quantity: Number(quantity),
        quantityUom: uom
      }));
    }
  };

  var onClickAddToCart = function onClickAddToCart() {
    var itemToAdd = {
      ryersonSku: item.materialMaster,
      quantity: Number(quantity),
      quantityUom: quantityMeasure,
      pricingUom: pricingMeasure,
      customerRefNumber: null,
      domesticRequired: false,
      notes: null,
      purchaseOrderNumber: null,
      customerPartNumber: (0, frontend_common_1.getCustomerPartNumber)((item === null || item === void 0 ? void 0 : item.altPartNumber) || ""),
      category: item.category,
      form: item.form
    };
    addToCart(axiosInstance, isLoggedIn, [itemToAdd], handleOnSuccessAddToCart);
  };

  var handleOnSuccessAddToCart = function handleOnSuccessAddToCart(response) {
    setSearchAddedToCart(true); // set flag to warn cart to update

    if (!isLoggedIn || (response === null || response === void 0 ? void 0 : response.data)) {
      sendAddToCartNotification(item);
    }

    setDeliveryTimesForSingleItem([]);
    setDeliveryTimes([]);
    setTriggerDeliveryTimes(true);
  };

  var getLeadTime = function getLeadTime(deliveryTimes) {
    var _a;

    var leadTimes = deliveryTimes.find(function (times) {
      return times.materialSku === item.materialMaster;
    });
    return (leadTimes === null || leadTimes === void 0 ? void 0 : leadTimes.leadTimeDays) && ((_a = (0, frontend_common_1.getMaxLeadTimeDay)(leadTimes === null || leadTimes === void 0 ? void 0 : leadTimes.leadTimeDays)) === null || _a === void 0 ? void 0 : _a.totalLeadTime);
  };

  var sendAddToCartNotification = function sendAddToCartNotification(item) {
    if (item) {
      var mappedItem = Object.assign(Object.assign({}, item), {
        comboKey: item.comboKey || "",
        quantity: quantity,
        quantityUOM: quantityMeasure,
        priceUOM: pricingMeasure,
        leadTime: getLeadTime(deliveryTimesForSingleItem || deliveryTimes),
        form: item === null || item === void 0 ? void 0 : item.form,
        leadTimeDisplay: (0, frontend_common_1.getLeadTimeRangeDisplay)(leadTimeDays, language)
      });
      var messageId = new Date().getTime();
      var notification = (0, jsx_runtime_1.jsx)(frontend_application_1.AddToCartNotification, {
        products: [mappedItem],
        messageId: messageId,
        storeDirectory: storeDirectory
      });
      var _message2 = {
        id: messageId,
        timeOut: 5000,
        type: "add-to-cart",
        message: notification
      };
      addNotification(_message2);
    }
  };
  /**
   * We don’t traditionally just pass objects with the `{...Props}` syntax,
   * but in this case, the object is typed, so mistakes and typos
   * will get caught by TS.
   */


  var Props = {
    item: item,
    qtyUomOption: qtyUomOption,
    pricingUomOption: pricingUomOption,
    quantity: quantity,
    quantityMeasure: quantityMeasure,
    pricingMeasure: pricingMeasure,
    isDebouncing: isDebouncing,
    hasError: hasError,
    setHasError: setHasError,
    leadTimeDays: leadTimeDays,
    addDefaultSrc: addDefaultSrc,
    getCorrectCase: getCorrectCase,
    canCartViewEdit: canCartViewEdit,
    generateProductUrl: generateProductUrl,
    onQuantityUpdate: onQuantityUpdate,
    onPricingMeasureChange: onPricingMeasureChange,
    onClickAddToCart: onClickAddToCart,
    index: index
  };
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: isMobile ? (0, jsx_runtime_1.jsx)(SearchResultItemMobile_v2_1.default, Object.assign({}, Props)) : (0, jsx_runtime_1.jsx)(SearchResultItemDesktop_v2_1.default, Object.assign({}, Props))
  });
};

exports.default = SearchResultItem_v2;